<template>
  <!-- 导航开始 -->
  <div class='commonClientinfoshow' ref="commonClientinfoshow">
    <div class="showBox" v-if="!isShowModifyBox">
      <table class="table table-bordered">
        <tr>
          <td v-if="info.path" colspan="2">
            <span>简历附件：</span>
            <a v-if="(info.path).substring((info.path).lastIndexOf('.')+1)!=='pdf'" :href="info.viewpath" class="badge badge-info"><i class="iconfont icon-xiazai-"></i> 附件下载</a>
            <a v-else target="_blank" :href="info.viewpath" class="badge badge-info"><i class="iconfont icon-file"></i> 打开pdf</a>
          </td>
          <td v-if="!info.path" colspan="2">
            <span>简历附件：</span> 未上传简历附件
          </td>
        </tr>
        <tr>
          <td colspan="2"><span>工作历程：</span>{{info.talk}}</td>
        </tr>
        <tr>
          <td colspan="2"><span>备注：</span>{{info.content}}</td>
        </tr>
        <tr>
          <td><span>姓名：</span>{{info.name}}</td>
          <td><span>经验：</span>{{info.experience}}</td>
        </tr>
        <tr>
          <td><span>职位：</span>{{info.position}}</td>
          <td><span>生日：</span>{{info.birthday}}</td>
        </tr>
      </table>
      <table class="table table-bordered">
        <tr>
          <td><span>希望薪资：</span>{{info.salary}}</td>
          <td><span>简历来源：</span>{{info.source_title}}</td>
        </tr>
        <tr>
          <td><span>简历标签：</span>{{info.tage_title}}</td>
          <td><span>简历评级：</span>{{info.lavel_title}}</td>
        </tr>
        <tr>
          <td><span>应聘部门：</span>{{info.department}}</td>
          <td><span>应聘职位：</span>{{info.position}}</td>
        </tr>
        <tr>
          <td><span>电话：</span>{{info.phone}}</td>
          <td><span>学历：</span>{{info.educational}}</td>
        </tr>
        <tr>
          <td colspan="2">
            <span>工作单位：</span>{{info.unit}}
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <span>居住地址：</span>{{info.address}}
          </td>
        </tr>
        <tr>
          <td><span>户籍：</span>{{info.car_address}}</td>
          <td><span>邮件：</span>{{info.email}}</td>
        </tr>
        <tr>
          <td><span>毕业学校：</span>{{info.school}}</td>
          <td><span>大学专业：</span>{{info.major}}</td>
        </tr>
        <tr>
          <td colspan="2">
            <span @click="delBoxFun()" class="text-danger cursor">
              <i v-if="isDelLoading" class='iconfont icon-jiazai xuanzhuan'></i>
              删除该简历
            </span>
          </td>
        </tr>
      </table>
      <span @click="modifyBoxFun(true)" class="tianjia btn btn-success btn-round">修改</span>
    </div>
    <div class="showModify" v-if="isShowModifyBox">
      <div class="box tow mb-3">
        <div class="a">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">姓名</span>
            </div>
            <input type="text" class="form-control" v-model="nameVal">
          </div>
        </div>
        <div class="b">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">经验</span>
            </div>
            <input type="text" class="form-control" v-model="experienceVal">
          </div>
        </div>
      </div>
      <div class="box tow mb-3">
        <div class="a">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">希望薪资</span>
            </div>
            <input type="text" class="form-control" v-model="salaryVal">
          </div>
        </div>
        <div class="b">
          <multiselect v-model="sourcetageVal" track-by="title" label="title" placeholder="来源" :options="sourcetageArr" :searchable="false"  :show-labels="false">
            <template slot="singleLabel" slot-scope="{ option }">{{ option.title }}</template>
          </multiselect>
        </div>
      </div>
      <div class="box tow mb-3">
        <div class="a">
          <multiselect v-model="leveltageVal" track-by="title" label="title" placeholder="标签" :options="leveltageArr" :searchable="false"  :show-labels="false">
            <template slot="singleLabel" slot-scope="{ option }">{{ option.title }}</template>
          </multiselect>
        </div>
        <div class="b">
          <multiselect v-model="resulttageVal" track-by="title" label="title" placeholder="评级" :options="resulttageArr" :searchable="false"  :show-labels="false">
            <template slot="singleLabel" slot-scope="{ option }">{{ option.title }}</template>
          </multiselect>
        </div>
      </div>
      <div class="box">
        <hr>
      </div>
      <div class="box tow mb-3">
        <div class="a">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">应聘部门</span>
            </div>
            <input type="text" class="form-control" v-model="departmentVal">
          </div>
        </div>
        <div class="b">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">应聘职位</span>
            </div>
            <input type="text" class="form-control" v-model="positionVal">
          </div>
        </div>
      </div>
      <div class="box tow mb-3">
        <div class="a">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">近期单位</span>
            </div>
            <input type="text" class="form-control" v-model="unitVal">
          </div>
        </div>
        <div class="b">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">联系电话</span>
            </div>
            <input type="text" class="form-control" v-model="phoneVal">
          </div>
        </div>
      </div>
      <div class="box tow mb-3">
        <div class="a">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">学校专业</span>
            </div>
            <input type="text" class="form-control" v-model="majorVal">
          </div>
        </div>
        <div class="b">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">学历</span>
            </div>
            <input type="text" class="form-control" v-model="educationalVal">
          </div>
        </div>
      </div>
      <div class="box tow mb-3">
        <div class="a">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">毕业院校</span>
            </div>
            <input type="text" class="form-control" v-model="schoolVal">
          </div>
        </div>
        <div class="b">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">邮件</span>
            </div>
            <input type="text" class="form-control" v-model="emailVal">
          </div>
        </div>
      </div>
      <div class="box tow mb-3">
        <div class="a">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">户籍</span>
            </div>
            <input type="text" class="form-control" v-model="car_addressVal">
          </div>
        </div>
        <div class="b">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">生日</span>
            </div>
            <input type="text" class="form-control" v-model="birthdayVal">
          </div>
        </div>
      </div>
      <div class="box mb-3">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">现居住地</span>
          </div>
          <input type="text" class="form-control" v-model="addressVal">
        </div>
      </div>

      <div class="biaodanBox mb-3">
        <uploader :options="options" @file-added="onFileAdded" @file-success="onFileSuccess" @file-error="onFileError" @file-removed="fileRemoved">
          <uploader-btn class="clearCss" :attrs="attrs">
            <div class="uploadBox">
              <div :class="{'text-success':!!filepath}" v-if="!isUploadLoading">{{filepath?'【已上传】':'【上传附件】'}}</div>
              <div v-else><i class='iconfont icon-jiazai xuanzhuan'></i> 上传中···</div>
            </div>
          </uploader-btn>
        </uploader>
      </div>

      <div class="box mb-3">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">工作历程</span>
          </div>
          <input type="text" class="form-control" v-model="talkVal">
        </div>
      </div>
      <div class="box mb-3">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">备注</span>
          </div>
          <input type="text" class="form-control" v-model="contentVal">
        </div>
      </div>
      <div class="box mb-3 text-center">
        <button @click="modifyBoxFun(false)" type="button" class="btn btn-light btn-round">取消</button>
        <button @click="storeFun" type="button" class="btn btn-success btn-round">
          <i v-if="isLoading" class='iconfont icon-jiazai xuanzhuan'></i>
          修改
        </button>
      </div>
    </div>
    <div class="searchLoadingBox" v-if="isSearchLoading">
      <span>
        <i class='iconfont icon-jiazai xuanzhuan'></i>
      </span>
    </div>
  </div>
  <!-- 导航结束 -->
</template>

<script>
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import resultCommons from '@/util/resultcommons';
import { EventBus } from '@/util/eventBus';
import { mapGetters } from 'vuex';
import * as types from '@/store/types';

export default {
  name: 'commonClientinfoshow',
  props: ['token', 'parentInitResumeFun'],
  data() {
    return {
      filepath: '',
      isUploadLoading: false,

      isShowModifyBox: false,
      info: {},
      // 提交中
      isLoading: false,
      // 删除中
      isDelLoading: false,

      // 名称
      nameVal: '',
      // 经验
      experienceVal: '',
      // 希望薪资
      salaryVal: '',
      // 来源
      sourcetageVal: null,
      // 标签
      leveltageVal: null,
      // 评级
      resulttageVal: null,
      // 应聘部门
      departmentVal: '',
      // 应聘职位
      positionVal: '',
      // 最近工作单位
      unitVal: '',
      // 出生年份
      birthdayVal: '',
      // 学历
      educationalVal: '',
      // 现居住地址
      addressVal: '',
      // 户籍地
      car_addressVal: '',
      // 电话
      phoneVal: '',
      // 邮箱
      emailVal: '',
      // 毕业学校
      schoolVal: '',
      // 专业
      majorVal: '',
      // 我司谈话
      talkVal: '',
      // 描述
      contentVal: '',
      // 来源
      sourcetageArr: [
        { name: '前程无忧', id: '1' },
        { name: 'boss直聘', id: '2' },
      ],
      // 标签
      leveltageArr: [
        { name: '重点维护', id: '1' },
        { name: '储备', id: '2' },
      ],
      // 评级
      resulttageArr: [
        { name: '优秀', id: '1' },
        { name: '良', id: '2' },
      ],
      // 加载中
      isSearchLoading: true,
      attrs: {
        accept: 'application/x-gzip,application/zip,application/rar,application/x-tar,application/pdf,application/msword',
      },
    };
  },
  computed: {
    ...mapGetters({
      localUser: types.GET_LOCALUSER,
    }),
    options() {
      return {
        target: process.env.IMAGE_UPLOAD_URL,
        testChunks: false,
        singleFile: true,
        chunkSize: 200 * 1024 * 1024,
        fileParameterName: 'UploadFormfile[imgFile]',
        query: {
          dir: 'resume',
        },
        headers: {
          Authorization: this.localUser.token,
        },
      };
    },
    whereObj() {
      return {
        path: this.filepath,
        name: this.nameVal,
        experience: this.experienceVal,
        salary: this.salaryVal,
        source_id: this.sourcetageVal ? this.sourcetageVal.id : '',
        lavel_id: this.leveltageVal ? this.leveltageVal.id : '',
        tage_id: this.resulttageVal ? this.resulttageVal.id : '',
        department: this.departmentVal,
        position: this.positionVal,
        unit: this.unitVal,
        birthday: this.birthdayVal,
        educational: this.educationalVal,
        address: this.addressVal,
        car_address: this.car_addressVal,
        phone: this.phoneVal,
        email: this.emailVal,
        school: this.schoolVal,
        major: this.majorVal,
        talk: this.talkVal,
        content: this.contentVal,
        token: this.token,
      };
    },
  },
  methods: {
    onFileAdded(file) {
      // 判断文件大小
      const size = file.file.size;
      if (size > process.env.IMAGE_UPLOAD_SIZE) {
        file.pause();
        this.$message.showMsgBox({
          type: 'success',
          content: '文件过大',
        });
      }
    },
    onFileSuccess(rootFile, file, response, chunk) {
      // 上传选择后
      const result = JSON.parse(response);
      if (result.state === 200) {
        this.filepath = result.data.path;
        this.$message.showMsgBox({
          type: 'success',
          content: '上传成功',
        });
      } else {
        this.$message.showMsgBox({
          type: 'error',
          content: result.message,
        });
      }
      this.isUploadLoading = false;
    },
    onFileError(file) {
      console.log(file, 'onFileError');
      // 上传选择后
      this.$message.showMsgBox({
        type: 'error',
        content: '上传失败',
      });
    },
    fileRemoved(file) {
      console.log(file, 'fileRemoved');
    },
    // 切换
    modifyBoxFun(bool) {
      this.$refs.commonClientinfoshow.scrollTop = 0;
      this.isShowModifyBox = bool;
    },
    // 初始化简历
    initResumeFun() {
      this.isSearchLoading = true;
      resultCommons.apiResumelistinfo(this, { token: this.token }).then((ob) => {
        if (ob.state === 200) {
          this.info = ob.data;
          this.filepath = ob.data.path;
          this.nameVal = ob.data.name;
          this.experienceVal = ob.data.experience;
          this.salaryVal = ob.data.salary;
          this.nameVal = ob.data.name;
          this.nameVal = ob.data.name;
          this.nameVal = ob.data.name;
          this.departmentVal = ob.data.department;
          this.positionVal = ob.data.position;
          this.unitVal = ob.data.unit;
          this.birthdayVal = ob.data.birthday;
          this.educationalVal = ob.data.educational;
          this.addressVal = ob.data.address;
          this.car_addressVal = ob.data.car_address;
          this.phoneVal = ob.data.phone;
          this.emailVal = ob.data.email;
          this.schoolVal = ob.data.school;
          this.majorVal = ob.data.major;
          this.talkVal = ob.data.talk;
          this.contentVal = ob.data.content;
          this.sourcetageVal = { id: ob.data.source_id, title: ob.data.source_title };
          this.leveltageVal = { id: ob.data.lavel_id, title: ob.data.lavel_title };
          this.resulttageVal = { id: ob.data.tage_id, title: ob.data.tage_title };
        } else {
          this.$message.showMsgBox({ type: 'warning', content: ob.message });
        }
        this.isSearchLoading = false;
      });
    },
    // 提交表单
    storeFun() {
      // 遮罩
      EventBus.$emit('globalZhezhaoBoxFun', true);
      // 加载中
      this.isLoading = true;
      // 可以执行登录
      resultCommons.apiResumelistmodify(this, this.whereObj).then((ob) => {
        // 取消加载
        this.isLoading = false;
        // 遮罩
        EventBus.$emit('globalZhezhaoBoxFun', false);
        if (ob.state === 200) {
          // 初始化简历
          this.initResumeFun();
          // 初始化父级简历
          this.parentInitResumeFun();
          // 更新根目录列表数据
          EventBus.$emit('rootIsSuccessResumeFun', { type: 3, ob: [this.token] });
          // 更新面试队列
          EventBus.$emit('rootIsSuccessInterviewFun', { type: 4, ob: this.whereObj });
          // 隐藏修改表单
          this.isShowModifyBox = false;
          this.$message.showMsgBox({ type: 'success', content: ob.message });
        } else {
          this.$message.showMsgBox({ type: 'warning', content: ob.message });
        }
      });
    },
    delBoxFun() {
      // 遮罩
      EventBus.$emit('globalZhezhaoBoxFun', true);
      // 加载中
      this.isDelLoading = true;
      // 可以执行登录
      resultCommons.apiResumelistdel(this, { token: this.token }).then((ob) => {
        // 取消加载
        this.isDelLoading = false;
        // 遮罩
        EventBus.$emit('globalZhezhaoBoxFun', false);
        // 加载中
        this.isDelLoading = false;
        if (ob.state === 200) {
          // 更新根目录列表数据
          EventBus.$emit('rootIsSuccessResumeFun', { type: 2, ob: [this.token] });
          // 隐藏修改表单
          this.$message.showMsgBox({ type: 'success', content: ob.message });
        } else {
          this.$message.showMsgBox({ type: 'warning', content: ob.message });
        }
      });
    },
  },
  components: {
    Multiselect,
  },
  created() {
    // 初始化简历
    this.initResumeFun();
    // 初始化三个标签
    resultCommons.apiResumetagesArr(this, {}).then((ob) => {
      if (ob.state === 200) {
        this.sourcetageArr = ob.data.source.child;
        this.leveltageArr = ob.data.lavel.child;
        this.resulttageArr = ob.data.tage.child;
      } else {
        this.$message.showMsgBox({ type: 'warning', content: ob.message });
      }
    });
  },
  mounted() {
  },
  destroyed() {
  },
};
</script>

<style scoped lang='less'>
.commonClientinfoshow{
  flex: 1;
  overflow-y: auto;
  background: #F6F6F6;
  span.tianjia{
    position: absolute;
    display: inline-block;
    width: 90px;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    margin-bottom: 20px;
    text-align: center;
    box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);
  }
  div.showModify{
    padding: 15px;
    background: #F6F6F6;
    div.box{
      hr{
        background: #FFFFFF;
      }
      input{
        color: #1586FF;
      }
      &.tow{
        display: flex;
        div.a{
          flex: 1;
          margin-right: 20px;
        }
        div.b{
          flex: 1;
        }
      }
    }
  }
  .showBox{
    padding: 15px;
    table{
      &.table-bordered{
        border-radius: 10px;
      }
      tr{
        td{
          //border: 0;
          span{
            color: #999999;
          }
          div.flex{
            display: flex;
            div{
              flex: 1;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/recruiment/info.vue